import React, { useState, useEffect } from 'react';
import { sociallinks } from '../../constants/';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { motion } from 'framer-motion';
import './Navbar.scss';
const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const [currentPage, setCurrentPage] = useState('home');
  const openSocial = (link) => {
    window.open(link, '_blank');
  };
  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash === '#learnmore') {
        setCurrentPage('learnmore');
      } else if (window.location.hash === '#games') {
        setCurrentPage('games');
      } else {
        setCurrentPage('home');
      }
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <h1>VEDANT</h1>
      </div>
      <ul className="app__navbar-links">
        {currentPage === 'home' && (
          <>
            <motion.li
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__flex p-text"
            >
              <div />
              <a href="#home">home</a>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__flex p-text"
            >
              <div />
              <a href="#about">about</a>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__flex p-text"
            >
              <div />
              <a href="#work">work</a>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__flex p-text"
            >
              <div />
              <a href="#skills">skills</a>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__flex p-text"
            >
              <div />
              <a href="#testimonial">testimonial</a>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__flex p-text"
            >
              <div />
              <a href="#learnmore" onClick={() => setCurrentPage('learnmore')}>
                learnmore
              </a>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__flex p-text"
            >
              <div />
              <a href="#games" onClick={() => setCurrentPage('games')}>
                Games
              </a>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__flex p-text"
            >
              <div />
              <a href="#contact">contact</a>
            </motion.li>
          </>
        )}
        {currentPage === 'games' && (
          <>
            <motion.li
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__flex p-text"
            >
              <div />
              <a href="#textgame">StoryGame</a>
            </motion.li>
          </>
        )}
        {currentPage === 'learnmore' && (
          <>
            <motion.li
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__flex p-text"
            >
              <div />
              <a href="#education">Education</a>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__flex p-text"
            >
              <div />
              <a href="#otherskills">Other-Skills</a>
            </motion.li>
          </>
        )}
      </ul>
      <button
        className="resume-button"
        onClick={() => {
          openSocial(sociallinks.resume);
        }}
      >
        Download Resume
      </button>
      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />
        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: 'easeOut' }}
          >
            <HiX onClick={() => setToggle(false)} />
            <ul>
              {[
                'home',
                'about',
                'work',
                'skills',
                'testimonial',
                'contact',
                'learnmore',
                'games',
              ].map((item) => (
                <motion.li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(false)}>
                    {item}
                  </a>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};
export default Navbar;
